import { useUserStore } from './modules/user'
import { usePlatformStore } from './modules/platform'

export default function useStore(): { user: ReturnType<typeof useUserStore>; platform: ReturnType<typeof usePlatformStore> } {
    return {
        user: useUserStore(),
        platform: usePlatformStore(),
    }
}
